import { sourcesAtom } from '@/stores/sourcesStore';
import { useAtomValue } from 'jotai';
import { User } from 'lucide-react';

export const SourceName = ({ sourceId }: { sourceId: string }) => {
  const sources = useAtomValue(sourcesAtom);

  const handleGetSourceName = (sourceId: string) => {
    const source = sources.find(source => source.id === sourceId);

    if (!source) {
      return sourceId.slice(0, 8);
    }

    return `${source.firstName} ${source.lastName}`;
  };

  return (
    <div className='flex items-center gap-1'>
      <User className='h-3 w-3' />
      <span>Source: {handleGetSourceName(sourceId)}</span>
    </div>
  );
};
